"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _cssInJs = require("@compiled/css-in-js");

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("./hooks");

var _data = require("./data");

var _errorBoundary = require("./errorBoundary");

var _this = void 0,
    _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/label.tsx";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof2["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var LabelData = /*#__PURE__*/function (_Data) {
  (0, _inherits2["default"])(LabelData, _Data);

  var _super = _createSuper(LabelData);

  function LabelData() {
    (0, _classCallCheck2["default"])(this, LabelData);
    return _super.apply(this, arguments);
  }

  return LabelData;
}(_data.Data);

__decorate([(0, _data.column)('Name')], LabelData.prototype, "name", void 0);

__decorate([(0, _data.column)('Icon', {
  type: 'url'
})], LabelData.prototype, "icon", void 0);
/** Component displaying a simple label for the specified game data, with icon if available. */


var Label = function Label(props) {
  return /*#__PURE__*/_react["default"].createElement(_errorBoundary.ErrorBoundary, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 34
    }
  }, /*#__PURE__*/_react["default"].createElement(LabelImplementation, (0, _extends2["default"])({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 3
    }
  })));
};

exports.Label = Label;
var LabelImplementation = /*#__PURE__*/(0, _react.memo)(function Label(_ref) {
  var _ref2, _data$name;

  var sheet = _ref.sheet,
      id = _ref.id,
      placeholderName = _ref.placeholderName;
  var data = (0, _hooks.useGameData)({
    sheet: sheet,
    columns: LabelData,
    id: id
  });
  var name = (_ref2 = (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : placeholderName) !== null && _ref2 !== void 0 ? _ref2 : 'Loading';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, data && /*#__PURE__*/_react["default"].createElement(LabelIcon, {
    src: data.icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 4
    }
  }, name));
});

var LabelIcon = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var _ref3$as = _ref3.as,
      C = _ref3$as === void 0 ? "img" : _ref3$as,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 88
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "pl7rlv",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 92
    }
  }, [".cc-pl7rlv{margin-right:0.2em;height:1.2em;vertical-align:middle}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-pl7rlv" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 186
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  LabelIcon.displayName = "LabelIcon";
}

var Text = /*#__PURE__*/_react["default"].forwardRef(function (_ref4, ref) {
  var _ref4$as = _ref4.as,
      C = _ref4$as === void 0 ? "span" : _ref4$as,
      props = (0, _objectWithoutProperties2["default"])(_ref4, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 84
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1oc1af1",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 88
    }
  }, [".cc-1oc1af1{-webkit-text-decoration:underline dotted;text-decoration:underline dotted}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1oc1af1" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 204
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Text.displayName = "Text";
}